import { AppButton, AppConfirmDeleteDialog, AppDataTable } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { TaskSaveDialog } from '@opportunities/-components/TaskSaveDialog'
import { Plus } from 'lucide-react'
import { AppExcelDownloadButton } from '@/components/AppExcelDownloadButton'
import { excelColumns } from './-lib/excel-columns'
import { useTasksTab } from './hooks/useTasksTab'

interface TasksTabProps {
  opportunityId: number
  salesforceProjectId: number | null
  editable: boolean
}

export function TasksTab({ opportunityId, salesforceProjectId, editable }: TasksTabProps) {
  const {
    tasks,
    isLoading,
    error,
    columns,
    sortKey,
    sortDirection,
    handleSortChange,
    dialogOpen,
    setDialogOpen,
    editingTask,
    handleAddTask,
    deleteDialogOpen,
    setDeleteDialogOpen,
    deletingTask,
    handleConfirmDelete,
    isDeleting,
  } = useTasksTab({ opportunityId, editable })

  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      {/* ツールバー */}
      <div className='flex justify-end items-center gap-2 px-4 pb-4'>
        <AppExcelDownloadButton
          data={tasks}
          columns={excelColumns}
          filename='タスク一覧'
          sortKey={sortKey}
          sortDirection={sortDirection}
          sortColumns={columns}
        />

        {editable && (
          <AppButton onClick={handleAddTask}>
            <Plus className='h-4 w-4 mr-1' />
            タスク追加
          </AppButton>
        )}
      </div>

      {/* タスク一覧テーブル */}
      <AppDataTable
        data={tasks}
        columns={columns}
        isLoading={isLoading}
        errorMessage={error ? `タスクの取得に失敗しました: ${error.message}` : undefined}
        pageSize={20}
        sortKey={sortKey}
        sortDirection={sortDirection}
        onSortChange={handleSortChange}
        getRowKey={(row) => row.id}
        emptyMessage='タスクはまだありません'
        columnSelector={{
          cookieKey: 'opportunity-tasks-columns',
          targetColumnKey: 'action',
        }}
        containerClassName='pb-4'
      />

      {/* タスク追加・編集ダイアログ */}
      <TaskSaveDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        opportunityId={opportunityId}
        salesforceProjectId={salesforceProjectId}
        task={editingTask}
      />

      {/* タスク削除確認ダイアログ */}
      <AppConfirmDeleteDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        subtitle={`タスク名: ${deletingTask?.title}`}
        additionalMessages={['削除後は元に戻すことはできません。']}
        onConfirm={handleConfirmDelete}
        isPending={isDeleting}
      />
    </div>
  )
}
